/**
 * Route metadata lookup table used by helpers in `./Utils.tsx`
 * (getRouteID, getRoutePathFromRouteID).
 *
 * Runtime routing is owned by React Router framework mode (`app/routes.ts`).
 * This file intentionally does NOT import any route components — keeping it
 * metadata-only prevents pulling chart code into chunks that only need to
 * resolve a path from a RouteID.
 */
import { RouteID } from "./routes";

export interface RouteMetadata {
  id: RouteID;
  path: string;
}

const entries: RouteMetadata[] = [
  { id: RouteID.Landing, path: "/" },

  { id: RouteID.Explore, path: "/explore" },
  { id: RouteID.TreeMap, path: "/explore/treemap" },
  { id: RouteID.GeoMap, path: "/explore/geomap" },
  { id: RouteID.OverTime, path: "/explore/overtime" },
  { id: RouteID.MarketShare, path: "/explore/marketshare" },
  { id: RouteID.ProductSpace, path: "/explore/productspace" },
  { id: RouteID.Feasibility, path: "/explore/feasibility/*" },

  { id: RouteID.Learn, path: "/learn" },
  { id: RouteID.Glossary, path: "/glossary" },
  { id: RouteID.FAQ, path: "/faq" },
  { id: RouteID.DataDownloads, path: "/data-downloads" },
  { id: RouteID.About, path: "/about" },
  { id: RouteID.TradeDataMethodology, path: "/trade-data-methodology" },
  {
    id: RouteID.TradeDataMethodologyPresentation,
    path: "/trade-data-methodology/presentation",
  },

  { id: RouteID.AtlasUI, path: "/atlas-ui" },
  { id: RouteID.PackageDocs, path: "/packages" },

  { id: RouteID.CountryProfiles, path: "/countries/*" },
  { id: RouteID.CountryRankings, path: "/rankings/*" },
  { id: RouteID.GrowthProjections, path: "/press-release/*" },
];

export const routesAsSet: Set<RouteMetadata> = new Set(entries);
